import {BaseModel} from "../base";

class AdminAdministratorModel extends BaseModel {
}

export {
    AdminAdministratorModel
}